/**
 * Wallets pad gas estimates inconsistently, nested bundle calls lose gas at every
 * level, and vault state can drift between estimation and inclusion. Keep headroom
 * for EOAs and contract wallets. `@repo/web3`'s `walletManagesGas` skips this buffer for Safe
 * batches and Tempo Accounts, which provide their own gas management.
 */
const TRANSACTION_GAS_BUFFER_PERCENT = 15n

/**
 * Covers one Morpho Blue market whose `_accrueInterest` the estimate skipped because the
 * estimation block already updated it; the tx lands a block later and pays for it (~25k-31k gas
 * on Base, Polygon and Ethereum). Most chains charge gas used, but Monad bills the full limit
 * (~$0.00008 extra per tx).
 */
const SKIPPED_ACCRUAL_GAS_HEADROOM = 30_000n

export function addTransactionGasBuffer(gasEstimate: bigint): bigint {
  return (
    (gasEstimate * (100n + TRANSACTION_GAS_BUFFER_PERCENT) + 99n) / 100n +
    SKIPPED_ACCRUAL_GAS_HEADROOM
  )
}
